import { API_URL } from '../../../app-config/constants';
import type { Answer, CycleFeedbackAnswer } from '../../../types/FeedbackQuestionnaire';
import type { AnytimeFeedbackResponseDto } from '../../../types/FeedbackResponseDto';
import { get as httpGet, post } from '../request';

const BASE_URL = `${API_URL}/anytime-feedback-response`;

const toUrl = (requestId: string, reviewerId: string) => `${BASE_URL}/${requestId}/${reviewerId}`;

const executeCommand = (
    requestId: string,
    reviewerId: string,
    command: string,
    postData?: any
): Promise<AnytimeFeedbackResponseDto> => post(`${toUrl(requestId, reviewerId)}/${command}`, { postData });

get.operation = 'READ';
export function get(requestId: string, reviewerId: string): Promise<AnytimeFeedbackResponseDto> {
    return httpGet(toUrl(requestId, reviewerId));
}

share.operation = 'COMMAND';
export function share(requestId: string, reviewerId: string): Promise<AnytimeFeedbackResponseDto> {
    return executeCommand(requestId, reviewerId, 'share');
}

reopen.operation = 'COMMAND';
export function reopen(requestId: string, reviewerId: string): Promise<AnytimeFeedbackResponseDto> {
    return executeCommand(requestId, reviewerId, 'reopen');
}

decline.operation = 'COMMAND';
export function decline(requestId: string, reviewerId: string): Promise<AnytimeFeedbackResponseDto> {
    return executeCommand(requestId, reviewerId, 'decline');
}

answer.operation = 'COMMAND';
export function answer(
    requestId: string,
    reviewerId: string,
    answers: Answer[] | CycleFeedbackAnswer[]
): Promise<AnytimeFeedbackResponseDto> {
    return executeCommand(requestId, reviewerId, 'answer', answers);
}
